import { FilterDimensionSelection } from '@Portal/models/smartFilters/FilterDimensionSelection';
import { SmartFilter } from '@Portal/models/smartFilters/SmartFilter';

export class SmartFilterSelectionViewModel {
  smartFilters: SmartFilter[];
  filterDimensionSelection?: FilterDimensionSelection;
  includeSiblings = true;
  ignoreClaims = false;
  smartDataTags: string[] = [];

  constructor(smartFilters: SmartFilter[]) {
    this.smartFilters = smartFilters;
  }
}
